import { ApiService } from "./AbstractApiService";
import {
  ILookup,
  ILookupDataModel,
  ILookupLangModel,
} from "@/interfaces/iLookup";
import qs from "qs";
import { IPageModel } from "@/interfaces/iPageModel";
import API from "./handlers/base.service";
import moment from "moment";
export class LookupAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: LookupAPI | null;
  constructor() {
    super("static-data");
  }
  public async getLookupList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<ILookup>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("lookups", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }

  public async addLookup(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ILookup>> {
    if (edit) {
      return this.put("lookups/" + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post("lookups", payload).then((response) => response.data);
    }
  }
  public bulkDeleteEntity(entity: string, params: string[]) {
    return this.service
      .delete(`${entity}`, { data: params })
      .then((response) => response.data);
  }
  public async getLookupModelList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<ILookupDataModel>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get(`lookupsData`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async addSMSConfig(payload?: Array<any>): Promise<any> {
    return this.put("configuration/addOrUpdateAll", payload).then(
      (response) => response.data
    );
  }
  public async getKeys(): Promise<any> {
    return this.get(
      "configuration/hierarchical?keys=TWILIO_CREDENTIALS_ACCOUNT_SERVICE_SID,TWILIO_CREDENTIALS_ACCOUNT_OAUTH_TOKEN,VYZOR_BATCH_USER_ID"
    ).then((response) => response.data);
  }
  public async getLookupLangList(
    id: number,
    params?: Record<string, string | number>
  ): Promise<IPageModel<ILookupLangModel>> {
    return this.get(`lookupsData/${id}/lookupsLang`, {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  public async submitCloneLookup(data): Promise<any> {
    return this.post("lookups/global", data).then((response) => response.data);
  }
  public async addLookupModelList(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ILookupDataModel>> {
    if (edit) {
      return this.put(`lookupsData/` + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post(`lookupsData`, payload).then(
        (response) => response.data
      );
    }
  }
  public async addLookupLang(
    payload?: Record<string, string | number>,
    edit?: boolean
  ): Promise<IPageModel<ILookupLangModel>> {
    if (edit) {
      return this.put(`lookupsLang/` + payload?.webId, payload).then(
        (response) => response.data
      );
    } else {
      return this.post(`lookupsLang`, payload).then(
        (response) => response.data
      );
    }
  }
  public transformDateRangeParams(
    params: Record<string, string | number>
  ): Record<string, string | number> {
    if (
      params &&
      params["startDate"] &&
      `${params["startDate"]}`.split(",").length > 1
    ) {
      const dates = `${params["startDate"]}`.split(",");
      params["startDate"] = moment(dates[0]).format("YYYY-MM-DDTHH:mm:ss[Z]");

      const endDate = new Date(dates[1]);
      endDate.setHours(23, 59, 59);

      // Format the end date as a string without converting to UTC
      const endDateString = `${endDate.getFullYear()}-${String(
        endDate.getMonth() + 1
      ).padStart(2, "0")}-${String(endDate.getDate()).padStart(
        2,
        "0"
      )}T${String(endDate.getHours()).padStart(2, "0")}:${String(
        endDate.getMinutes()
      ).padStart(2, "0")}:${String(endDate.getSeconds()).padStart(2, "0")}Z`;

      params["endDate"] = endDateString;
    }

    const { ...rest } = params;
    return rest;
  }
}

export async function getLookups<T extends string>(
  url: string
): Promise<Array<Record<any, any>>> {
  return API.get(url).then((res) => {
    return res.data;
  });
}

// const lookupCache = new Map<string, Promise<Array<Record<any, any>>>>();

// export async function getLookups<T extends string>(
//   url: string
// ): Promise<Array<Record<any, any>>> {
//   if (lookupCache.has(url)) {
//     return lookupCache.get(url)!;
//   }

//   const promise = API.get(url).then((res) => {
//     return res.data;
//   });

//   lookupCache.set(url, promise);
//   return promise;
// }

export function convertLookupsToFilters<T extends string>(
  lookups: Array<Record<any, any>>,
  key: string,
  value: string
) {
  if (key.split(".").length > 1) {
    const filters = lookups?.[key.split(".")[0]].map((item) => {
      return {
        label: item[key.split(".")[1]],
        // .toLowerCase()
        // .replace(/_/g, " ")
        // .replace(/\b\w/g, (char) => char.toUpperCase()),
        value: item[value.split(".")[1]],
      };
    });
    return filters;
  } else {
    const filters = lookups?.map((item) => {
      return {
        label: item[key],
        // .toLowerCase()
        // .replace(/_/g, " ")
        // .replace(/\b\w/g, (char) => char.toUpperCase()),
        value: item[value],
      };
    });
    return filters;
  }
}

export async function getLookupFilters(
  url: string,
  key: string,
  value: string
) {
  const lookups = await getLookups(url);
  return convertLookupsToFilters(lookups, key, value);
}
